import React, { useEffect, useState } from "react";
import { GetPendingBookingsAPI } from "network/bookings";

// Contatore oro accanto a My Bookings: prenotazioni In attesa da oggi in poi (nascosto se zero).
// Si aggiorna all'apertura, ogni 60 secondi e all'evento "bookings:changed".
const PendingBadge = () => {
  const [n, setN] = useState(0);
  useEffect(() => {
    let alive = true;
    const load = () => GetPendingBookingsAPI().then((r) => alive && setN(r?.total || 0)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    window.addEventListener("bookings:changed", load);
    return () => {
      alive = false;
      clearInterval(id);
      window.removeEventListener("bookings:changed", load);
    };
  }, []);
  if (!n) return null;
  return (
    <span
      className="badge badge-pill ml-1"
      style={{ background: "#b8932f", color: "#fff", fontSize: 10, verticalAlign: "middle" }}
    >
      {n}
    </span>
  );
};

export default PendingBadge;
